export const columns = [
    {
        label: 'ID',
        field: 'patienT_ID'
    },
    {
        label: 'Names',
        field: 'names',
    },
    {
        label: 'National ID',
        field: 'nationalid',
    },
    {
        label: 'DOB',
        field: 'dob',
    },
    {
        label: 'Cell Phone',
        field: 'celL_PHONE',
    },
    {
        label: 'IP File No',
        field: 'ipfileno',
    },
    {
        label: 'OP File No',
        field: 'opfileno',
    },
    {
        label: 'Visits',
        field: 'visitCount',
    },
    {
        label: 'Action',
        field: 'action',
    },
];
